import React from 'react';

const LeftArrow = (fill = '#000000') => (
  <g>
    <path
      d="M12.38,15.3,5.53,8.53,12.38,1.7,11.3.62,3.38,8.53l8,7.85Z"
      fill={fill}
    />
  </g>
);

export default LeftArrow;



// WEBPACK FOOTER //
// ./src/assets/svg-icons/leftArrow.js